export class SculptureForm { 
    sculptureFormID:number;
    name:string;
    surname:string; 
    email :string;
    birthdate :string;
    phone :string;
    website :string;
    address :string;
    attendedexhibitions:string; 
    sculpturename :string;
    productiondate :string;
    width :string;
    height :string;
    depth :string;
    material :string;
    weight :string;
    definition :string;
    videourl :string;
    photourl1 :string;
    photourl2 :string;
    photourl3 :string;
    photourl4 :string;
    photourl5 :string;  
   
    constructor(name :string, surname:string,email:string,birthdate:string, phone:string, website:string, address:string, attendedexhibitions:string,
        sculpturename:string,productiondate:string,width:string,height:string,depth:string,material:string,
        weight:string,definition:string,videourl:string,photourl1:string,photourl2:string,photourl3:string,photourl4:string,photourl5:string) {
        this.name = name;
        this.surname = surname;
        this.email = email;
        this.birthdate = birthdate;
        this.phone = phone;
        this.website = website;
        this.address= address;
        this.attendedexhibitions = attendedexhibitions;
        this.sculpturename = sculpturename;
        this.productiondate = productiondate;
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.material = material;
        this.weight = weight;
        this.definition = definition;
        this.videourl = videourl;
        this.photourl1 = photourl1;
        this.photourl2 = photourl2; 
        this.photourl3 = photourl3; 
        this.photourl4 = photourl4; 
        this.photourl5 = photourl5; 
    }
}
 